import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withCoreComponent } from 'core/hocs';
import { isEmptyOrNil } from 'core/helpers';
import { FormattedTag, GameTags as GameTagsCore } from 'core/components';
import { Carousel } from 'components/carousel/carousel';
import { GameTagsItem } from 'components/game-tags/game-tags-item/game-tags-item';

import './game-tags.scss';

const settings = {
  arrows: false,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 719,
      settings: {
        slidesToShow: 2.22,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        arrows: true,
      },
    },
  ],
};

export const GameTagsUI = ({
  gameTags,
  className,
  isInProgress,
}) => {
  if (isInProgress || isEmptyOrNil(gameTags)) {
    return null;
  }

  return (
    <div className={classNames('game-tags', className)}>
      <div className="mb-3 d-flex align-items-center">
        <FormattedTag
          id="games.game-tags"
          className="h4 mb-0 md-h3 text-large"
        />
      </div>

      <Carousel settings={settings}>
        {gameTags.map(({
          tagName,
          imageUrl
        }) => (
          <>
            <GameTagsItem tagName={tagName} imageUrl={imageUrl} />
          </>
        ))}
      </Carousel>
    </div>
  );
};

GameTagsUI.propTypes = {
  isInProgress: PropTypes.bool,
  gameTags: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
};

GameTagsUI.defaultProps = {
  isInProgress: false,
  gameTags: null,
  className: null,
};

export const GameTags = withCoreComponent(GameTagsCore, GameTagsUI);
